import localforage from 'localforage';
import { PersistedOfflineQueue } from './types';

const KEY = 'offline-queue';

export const loadQueue = async (): Promise<PersistedOfflineQueue> =>
  (await localforage.getItem(KEY)) ?? {
    queue: [],
    context: {},
    contextByCustomer: {},
  };

export const saveQueue = async (data: PersistedOfflineQueue) =>
  localforage.setItem(KEY, data);
